





















import Vue, { PropType } from "vue"
import { SearchSortOption } from "~/clStores/projectSearchParameterOption"

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    options: {
      type: Array as PropType<SearchSortOption[]>,
      required: true,
    },
  },
  methods: {
    isSelected(value: boolean): boolean {
      return this.value === value
    },
    handleInput(value: boolean) {
      this.$emit("input", value)
    },
  },
})
